import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { ClientSessionService } from './client-session.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private clientSessionService: ClientSessionService,
    private router: Router
  ) { }

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.clientSessionService.loggedIn) {
      return true;
    }

    this.router.navigate(['/login'], {
      queryParams: { redirectRoute: state.url }
    });
    return false;
  }
}
